import React from 'react';
import { QueryClientProvider } from 'react-query';
import { queryClient } from './utils/queryClient';

export const wrapRootElement = ({ element }: { element: React.ReactNode }) => (
  <QueryClientProvider client={queryClient}>{element}</QueryClientProvider>
);
